import { combineReducers } from 'redux'
import login from './login.reducer'
import snack from './snack.reducer'
import loader from './loader.reducer'

const reducers = combineReducers({
  loader,
  login,
  snack,
})

export default reducers
